import Container from '@ui/container/container';

const AudiencesSkeletonLoader = () => {
  const NUMBER_ROWS = 4;

  return (
    <Container className="flex fd-column">
      <Container height="calc(100vh - 200px)" style={{ position: 'relative', overflowY: 'hidden' }}>
        <Container className="flex fd-row margin-h-10 gap-14" height="88px" width="1006px">
          {Array.from({ length: 4 }).map((_, i) => (
            <Container
              key={i}
              height="88px"
              width="238px"
              skLoader={{
                height: 88,
                width: 238,
                radius: 16,
                loading: true,
                design: 'GlobalCont1',
              }}
            />
          ))}
        </Container>
        <Container
          width="992px"
          style={{ position: 'relative', overflowY: 'hidden' }}
          className="flex fd-row jc-space-between margin-t-34 margin-b-20 margin-h-10"
        >
          <Container
            height="37px"
            width="238px"
            skLoader={{
              height: 37,
              width: 238,
              radius: 8,
              loading: true,
              design: 'GlobalCont1',
              justify: 'flex-start',
            }}
          />
          <Container
            height="37px"
            width="238px"
            skLoader={{
              height: 37,
              width: 238,
              radius: 8,
              loading: true,
              design: 'GlobalCont1',
              justify: 'flex-end',
            }}
          />
        </Container>

        <Container
          width="992px"
          style={{ position: 'relative', overflowY: 'hidden' }}
          className="flex fd-column jc-space-between margin-h-10 gap-16"
        >
          {Array.from({ length: NUMBER_ROWS }).map((_, i) => (
            <Container key={i} height="162px" className="flex fd-row gap-16">
              <Container
                height="162px"
                width="320px"
                skLoader={{
                  height: 162,
                  width: 320,
                  radius: 12,
                  loading: true,
                  design: 'GlobalCont1',
                }}
              />
              <Container
                height="162px"
                width="320px"
                skLoader={{
                  height: 162,
                  width: 320,
                  radius: 12,
                  loading: true,
                  design: 'GlobalCont1',
                }}
              />
              <Container
                height="162px"
                width="320px"
                skLoader={{
                  height: 162,
                  width: 320,
                  radius: 12,
                  loading: true,
                  design: 'GlobalCont1',
                }}
              />
            </Container>
          ))}
        </Container>
      </Container>
    </Container>
  );
};

export default AudiencesSkeletonLoader;
